import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import Analytics from './web-analytics'
import Buefy from 'buefy'
import VeeValidate from 'vee-validate'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as VueGoogleMaps from 'vue2-google-maps'

Analytics()

Vue.use(VueGoogleMaps, {
  load: false
})
/*
Because we are loading the Google Maps JavaScript API manually/globally using a script tag (so it can be used
programmatically outside of .vue files), we need to tell the Vue plugin that the API has been loaded and it can init
ref: https://github.com/xkjyeah/vue-google-maps/blob/vue2/src/main.js#L107
 */
window.vueGoogleMapsInit()

Vue.use(Buefy, {
  defaultIconPack: 'fas'
})

library.add(fas)
library.add(far)
library.add(fab)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VeeValidate, {
  errorBagName: 'validationErrors',
  fieldsBagName: 'validationFields'
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if (to.matched.every((record) => record.meta.isPublic)) {
    next()
  } else {
    // TODO: check for auth before calling next() or redirect to login
    /*
    if (!loggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
    */
    next()
  }
})

router.afterEach((to) => {
  if (window.ga) {
    ga('set', 'page', to.path)
    ga('send', 'pageview')
  }
})
